<template>
  <figure
    class="image is-16by9 wrapper-embed"
    ref="youtubePlaceHolder"
    v-html="buildIframe()"
  ></figure>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: ''
    }
  },

  methods: {
    buildIframe() {
      let iframe = `
        <iframe 
          width="100%"
          height="100%"
          src="${this.getPlayerUrl()}?showinfo=0" 
          class="has-ratio"
          frameborder="0" 
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
          allowTransparency="true"
        >
        </iframe>
      `
      return iframe
    },

    getPlayerUrl() {
      let src = this.src
      let videoId = ''
      /**
       * Check if URL contains /watch
       * Or youtube short URL
       */
      if (src.indexOf('/embed') !== -1) {
        // Check if URL is the embed URL
        videoId = src.split('embed/')[1]
      } else if (src.indexOf('/watch') !== -1 && src.indexOf('?v=') !== -1) {
        // Check if URL contains watch
        videoId = src.split('v=')[1]
      } else if (src.indexOf('youtu.be') !== -1) {
        // Check if is youtube short URL
        videoId = src.split('.be/')[1]
      }
      return 'https://www.youtube-nocookie.com/embed/' + videoId
    }
  }
}
</script>

<style lang="scss" scoped>
iframe {
  background: transparent;
}
</style>